
//资源库首页最新上传组件
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {Icon, Modal} from 'antd';
import BaseComponent from '../../../../../base/BaseComponent';
import Titlepicfile from '../../../../components/titlepicfile/Titlepicfile'
import {formatSecondsFont, unitConvert} from "../../../../../utils";
import downLoad from '../img/download-outlined.png'

export default class File extends BaseComponent {
    static defaultProps = {
        checked: false,
        name: 'tttppp',
        size: '2.2M',
        pixel: '1920 x 1060',
        img: 'images/folder.png',
        width:'1200',
        height:'790',
        onClick: () => {
            console.log("点击");
        },
        IsChecked:()=>{

        },
        onDownloadCall:()=>{},
        file:{}
    };

    static propTypes = {
        name: PropTypes.string.isRequired,//传入dom 结构
        size: PropTypes.string.isRequired,//文件大小
        pixel:PropTypes.string.isRequired,//图片像素
        onClick: PropTypes.func,//点击函数
        IsChecked: PropTypes.func.isRequired,//选中的函数
        img:PropTypes.string.isRequired,//传入图标
        downloadImg:PropTypes.string,//下载的图标
        download:PropTypes.func
    };

    constructor(props) {
        super(props);
        this.state = {
            hover: false,
            picDown:""
        }
    }

    componentWillMount() {
    }

    componentDidMount() {
    }

    handleEnter() {

    }

    handleOut() {

    }

    render() {
        // 鼠标划过
        return (
            <div>
                {this.renderFileCard()}
            </div>)
    }
    handleEnter() {
        this.setState({hover: true})
    }

    handleOut() {
        this.setState({hover: false})
    }

    renderFileCard() {
        // 鼠标划过
        let show;
            if(this.state.hover){
                show='block'
            }else{
                show='none'

        }
         let showText ='';
          if(this.props.file.type ===1){
              showText = this.props.file.width+' x '+ this.props.file.height
          }else if(this.props.file.type ===2||this.props.file.type ===4){
              showText =this.props.file['duration']?formatSecondsFont(this.props.file['duration']/1000):"00分00秒"
          }else if(this.props.file.type ===3){
              showText= this.props.file.size?unitConvert(this.props.file.size):'0B'
          }
        return (
            <div style={{width: '104px'}} onMouseOver ={() => this.handleEnter()}
                 onMouseOut= {() => this.handleOut()}>
                <div style={{marginBottom: '8px', cursor: "pointer", width: '104px', position: "relative"}}
                    >
                    <div onClick={() => {this.props.onClick()}}>
                        <Titlepicfile style={{width: '88px', height: '88px', marginLeft: '8px'}}
                                      src={this.props.file.icon}  />
                    </div>

                    <div style={{
                        display:show,
                        width: '104px',
                        height: '20px',
                        background: "rgba(0,0,0,0.40)",
                        alignItems: "center",
                        position: "absolute",
                        bottom: "0",
                        zIndex: '2',
                        justifyContent: "space-around",
                        color: '#ffffff',
                        fontSize: '10px',
                        borderRadius: " 0 0 2px 2px"
                    }}>
                        <span style={{marginLeft:'10px',width:'75px',display: "inline-block",lineHeight:'20px'}}>{showText}</span>
                        <img src={downLoad} style={{marginTop:'-4px'}}  onClick={()=>{this.props.download&&this.props.download()}}/>
                    </div>
                </div>
                <div style={{height: "36px", textAlign: 'center', lineHeight: '18px', marginTop: 12}}>
                    <div className={'twoText'} style={{
                        fontSize: '14px',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        color: "rgba(0, 0, 0, 0.65)"
                    }} title={this.props.file.name}>{this.props.file.name}</div>
                    <div style={{
                        fontSize: '12px',
                        color: "rgba(0, 0, 0, 0.45"
                    }}>{this.props.file.size ? unitConvert(this.props.file.size) : '0B'}</div>
                </div>
                <Modal
                    visible={this.state.previewVisible}
                    footer={null}
                    onCancel={() => this.setState({ previewVisible: false })}>
                    <div>

                        {
                            this.props.type === 1 ? <img alt="example" style={{ width: '100%' }} src={this.state.previewImage} /> : <video controls={"controls"} style={{ width: '100%' }} src={this.state.previewImage} />
                        }
                    </div>
                </Modal>
            </div>


        )
    }


}
